// extracted by mini-css-extract-plugin
module.exports = {"buttonWrapper":"Button_buttonWrapper__LmI_F","load":"Button_load__9Bjzw"};